// Angular Core
import { Validators } from "@angular/forms";

// Interface
import { FormControlStructure } from "../../interfaces/FormControlStructure";

export const formControls: FormControlStructure[] = [
    {
      controlName: 'email',
      validators: [Validators.required, Validators.email],
      validatorsMessages: [
        {
          validatorName: 'email',
          errorMessage: 'Informe um e-mail válido'
        },
        {
          validatorName: 'required',
          errorMessage: 'E-mail é obrigatório'
        },
        {
          validatorName: 'invalid',
          errorMessage: 'E-mail ou senha são inválidos.'
        }
      ],
      initialValue: ''
    },
    {
      controlName: 'password',
      validators: [Validators.required],
      validatorsMessages: [
        {
          validatorName: 'required',
          errorMessage: 'Senha é obrigatória'
        },
        {
          validatorName: 'invalid',
          errorMessage: 'E-mail ou senha são inválidos.'
        }
      ],
      initialValue: ''
    }
  ]
